module.exports = __webpack_public_path__ + "static/media/christmasbox.01ea9fa2.png";